import { Segmented } from "./Segmented";

const OUTS = [0, 1, 2].map((v) => ({ value: v, label: `${v}` }));
const RUNNERS = [
  { value: 1, id: "1b", label: "1st" },
  { value: 2, id: "2b", label: "2nd" },
  { value: 4, id: "3b", label: "3rd" },
];
const HITS = [
  { value: "ground", label: "Ground" },
  { value: "fly", label: "Fly" },
  { value: "bunt", label: "Bunt" },
];

const Ctl = ({ label, children }) => (
  <div className="flex flex-col gap-1.5 min-w-0">
    <span className="ctl-label">{label}</span>
    {children}
  </div>
);

export const SituationControls = ({ outs, runners, hitType, onChange }) => {
  const active = RUNNERS.filter((r) => runners & r.value).map((r) => r.value);
  return (
    <div className="flex flex-wrap gap-x-4 gap-y-3" data-testid="situation-controls">
      <Ctl label="Outs">
        <Segmented options={OUTS} value={outs} onChange={(v) => onChange({ outs: v })} testPrefix="outs-toggle" />
      </Ctl>
      <Ctl label="Runners on">
        <Segmented options={RUNNERS} value={active} multi onChange={(v) => onChange({ runners: runners ^ v })} testPrefix="runner-toggle" />
      </Ctl>
      <Ctl label="Hit type">
        <Segmented options={HITS} value={hitType} onChange={(v) => onChange({ hitType: v })} testPrefix="hittype" />
      </Ctl>
    </div>
  );
};
